import React from 'react';

const Signup = () => {
  const externalUrl = 'https://learnhouse.io/login?orgslug=swiss-tech-academy';
  return (
    <div className="min-h-screen bg-white dark:bg-gray-900 flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 text-center">
        <h2 className="text-4xl font-extrabold text-gray-900 dark:text-white">
          Welcome to Swiss Tech Academy
        </h2>
        <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
          Access your account or sign up to start learning with us.
        </p>
        <div className="space-y-4">
          <button
            onClick={() => window.open(externalUrl, '_blank')}
            className="w-full inline-flex justify-center px-6 py-3 text-base font-medium text-white bg-purple-600 rounded-lg hover:bg-purple-700 transition duration-200"
          >
            Login
          </button>
          <button
            onClick={() => window.open(externalUrl, '_blank')}
            className="w-full inline-flex justify-center px-6 py-3 text-base font-medium text-purple-600 bg-white border border-purple-600 rounded-lg hover:bg-gray-100 transition duration-200"
          >
            Sign Up
          </button>
        </div>
      </div>
    </div>
  );
};

export default Signup;